/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core'
import EngageWidgetMyProfile from '../../../_metronic/partials/widgets/_new/engage/EngageWidgetMyProfile'
import OverviewMyProfile from '../../modules/apps/myprofile/OverviewMyProfile'
import MyProfileSettings from '../../modules/apps/myprofile/MyProfileSettings'
import { axiosClientAuth } from '../../utils'

export enum MyProfileTabs {
  'overview' = 'overview',
  'settings' = 'settings',
  'paymentreport' = 'paymentreport',
}

const MyProfile: FC = () => {
  const [tab, setTab] = useState(MyProfileTabs.overview)
  const [data, setData] = useState<any>({})
  const [peCount, setPeCount] = useState<number | null>(null)

  useEffect(() => {
    axiosClientAuth
      .get('/auth/profile/')
      .then((res) => setData(res.data?.data))
      .catch((err) => console.log(err))
    axiosClientAuth
      .get('/auth/users/', { params: { type: 'PE', page: 1, page_size: 1 } })
      .then((res) => setPeCount(res.data.data.count as number))
      .catch(() => {})
  }, [])

  return (
    <>
      <EngageWidgetMyProfile tab={tab} setTab={setTab} data={{ ...data, pe_user_count: peCount ?? 0 }} />
      {tab === MyProfileTabs.overview ? (
        <OverviewMyProfile data={data} setTab={setTab} />
      ) : (
        <MyProfileSettings data={data} />
      )}
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const MyProfileWrapper: FC = () => {
  const { setRightTolbar } = useLayout()

  useEffect(() => {
    setRightTolbar('')
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>My Profile</PageTitle>
      <MyProfile />
    </>
  )
}

export { MyProfileWrapper }
